
export const appID = 505878755;
export const serverSecret = "ced1387da8d44b4f9f58410c34e99988";
